// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wt630","fullView":"styles_fullView__3k2zm"};